/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'navigation.global-invite.error-state-description': 'Try refreshing the page or contact us if the problem persists.',
  'navigation.global-invite.error-state-heading': "We can't load the invite list right now",
  'navigation.global-invite.loading-visually-hidden-label': 'Loading',
  'navigation.global-invite.modal-dialog-label': 'Invite people',
};
